/**
 * @fileoverview XLSX utility wrapper module that exposes SheetJS library functions
 * @module utils/xlsx
 */

/** @type {Object} */
const _xlsx = window.XLSX;
/**
 *
 * @type {{read: *, utils: *, writeFile: *}}
 * @private
 */
const xlsx = {
  read: _xlsx?.read ?? function () { throw new Error('XLSX library is not loaded'); },
  utils: _xlsx?.utils ?? {
    sheet_to_json: function () { throw new Error('XLSX library is not loaded'); },
    json_to_sheet: function () { throw new Error('XLSX library is not loaded'); },
    cell_add_comment: function () { throw new Error('XLSX library is not loaded'); },
    book_new: function () { throw new Error('XLSX library is not loaded'); },
    book_append_sheet: function () { throw new Error('XLSX library is not loaded'); },
  },
  writeFile: _xlsx?.writeFile ?? function () { throw new Error('XLSX library is not loaded'); },
}



export default xlsx;